import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function SupportMenu({ openItem, activeItem }) {
  return (
    <li
      className={`nav-item has-treeview 
  ${sidebarHelper.checkOpenItem(openItem, "tickets")} `}
    >
      <a
        href="# "
        className={`nav-link  
  ${sidebarHelper.checkActiveItem(openItem, "tickets")} `}
      >
        <i className="nav-icon hl-messages"></i>
        <p>
          راهنما و پشتیبانی
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <a
            href={`${process.env.REACT_APP_DOMAIN_ADVERTISER}/ticket/all-ticket-user`}
            className="nav-link"
            target="_blank"
          >
            <i className="hl-microphone nav-icon"></i>
            <p> درخواست پشتیبانی</p>{" "}
          </a>
        </li>
        <li className="nav-item">
          <Link
            to="/help"
            className={`nav-link  
      ${sidebarHelper.checkActiveItem(activeItem, "help")} `}
          >
            <i className="hl-message-help nav-icon"></i>
            <p> راهنما </p>{" "}
          </Link>
        </li>
      </ul>
    </li>
  );
}
